/**
 * Per-user guide sandbox metadata.
 *
 * An interactive (sandbox:true) guide runs in the user's hidden practice
 * workspace. The group is created on first sandbox-guide start and persisted
 * across sessions; it starts empty - the user builds what they need during
 * the guide. (Earlier versions pre-populated example ledgers/budgets; that
 * scaffolding was removed in #823 because the hands-on intro reads cleanly
 * without it.)
 */

export const SANDBOX_GROUP_NAME = 'Practice Space';
